import React, { memo } from "react"
import Leaf from "./Leaf"
import Highlight from "./Highlight"
import KeyPassages from "../../data/KeyPassageList.json"
import ValuePassages from "../../data/YWAMVersesStandard.json"
import styles from "./ParaText.module.css"
import getStandardVerse from "../../scripts/getStandardVerse"
import ProseInline from "./InlineTypes/ProseInline"
import PoetryInline from "./InlineTypes/PoetryInline"
import ListInline from "./InlineTypes/ListInline"
import TableInline from "./InlineTypes/TableInline"
import OtherInline from "./InlineTypes/OtherInline"

const InlineElement = memo(
  ({
    isPsalmHeader,
    versification,
    version,
    language,
    showSpheres,
    showValues,
    content,
    iIndex,
    verbViewDialog,
    newInterlinearDialog,
    newSphereViewDialog,
    newValuesDialog,
    versificationType,
    availableBooks,
    navigateToRef,
    translate,
    displayRef,
    showQA,
    showGAP,
  }) => {
    const { type, children, start, tag } = content
    const emptyLeaf = {
      text: "",
    }
    if (type === "break") return null
    if (type === "prose") return (
      <ProseInline
        isPsalmHeader={isPsalmHeader}
        versification={versification}
        version={version}
        language={language}
        showSpheres={showSpheres}
        showValues={showValues}
        content={content}
        iIndex={iIndex}
        verbViewDialog={verbViewDialog}
        newInterlinearDialog={newInterlinearDialog}
        newSphereViewDialog={newSphereViewDialog}
        newValuesDialog={newValuesDialog}
        versificationType={versificationType}
        availableBooks={availableBooks}
        navigateToRef={navigateToRef}
        translate={translate}
        displayRef={displayRef}
        showQA={showQA}
        showGAP={showGAP}
      />
    )
    if (type === "poetry") return (
      <PoetryInline
        isPsalmHeader={isPsalmHeader}
        versification={versification}
        version={version}
        language={language}
        showSpheres={showSpheres}
        showValues={showValues}
        content={content}
        iIndex={iIndex}
        verbViewDialog={verbViewDialog}
        newInterlinearDialog={newInterlinearDialog}
        newSphereViewDialog={newSphereViewDialog}
        newValuesDialog={newValuesDialog}
        versificationType={versificationType}
        availableBooks={availableBooks}
        navigateToRef={navigateToRef}
        translate={translate}
        displayRef={displayRef}
        showQA={showQA}
        showGAP={showGAP}
      />
    )
    if (type === "list") return (
      <ListInline
        isPsalmHeader={isPsalmHeader}
        versification={versification}
        version={version}
        language={language}
        showSpheres={showSpheres}
        showValues={showValues}
        content={content}
        iIndex={iIndex}
        verbViewDialog={verbViewDialog}
        newInterlinearDialog={newInterlinearDialog}
        newSphereViewDialog={newSphereViewDialog}
        newValuesDialog={newValuesDialog}
        versificationType={versificationType}
        availableBooks={availableBooks}
        navigateToRef={navigateToRef}
        translate={translate}
        displayRef={displayRef}
        showQA={showQA}
        showGAP={showGAP}
      />
    )
    if (type === "table") return (
      <TableInline
        isPsalmHeader={isPsalmHeader}
        versification={versification}
        version={version}
        language={language}
        showSpheres={showSpheres}
        showValues={showValues}
        content={content}
        iIndex={iIndex}
        verbViewDialog={verbViewDialog}
        newInterlinearDialog={newInterlinearDialog}
        newSphereViewDialog={newSphereViewDialog}
        newValuesDialog={newValuesDialog}
        versificationType={versificationType}
        availableBooks={availableBooks}
        navigateToRef={navigateToRef}
        translate={translate}
        displayRef={displayRef}
        showQA={showQA}
        showGAP={showGAP}
      />
    )
     return (
       <OtherInline
         isPsalmHeader={isPsalmHeader}
         versification={versification}
         version={version}
         language={language}
         showSpheres={showSpheres}
         showValues={showValues}
         content={content}
         iIndex={iIndex}
         verbViewDialog={verbViewDialog}
         newInterlinearDialog={newInterlinearDialog}
         newSphereViewDialog={newSphereViewDialog}
         newValuesDialog={newValuesDialog}
         versificationType={versificationType}
         availableBooks={availableBooks}
         navigateToRef={navigateToRef}
         translate={translate}
         displayRef={displayRef}
         showQA={showQA}
         showGAP={showGAP}
       />
     )
  }
)

export default InlineElement
